var styles = {"container":"styles_container__1h2xy p2","inner-message-bubble":"styles_inner-message-bubble__1pRbU mb2","innerMessageBubble":"styles_inner-message-bubble__1pRbU mb2","copy-row":"styles_copy-row__3Jl65 p0","copyRow":"styles_copy-row__3Jl65 p0","message-row":"styles_message-row__1XMST p0","messageRow":"styles_message-row__1XMST p0"};

export default styles;
//# sourceMappingURL=styles.css.js.map
